import { render, staticRenderFns } from "./BlockFormComponent.vue?vue&type=template&id=7d94d4c1"
import script from "./BlockFormComponent.vue?vue&type=script&lang=js"
export * from "./BlockFormComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports